(function () {

  'use strict';

  eclipseApp.directive('customFieldError', function() {

    return {
      require: 'ngModel',
      link: function(scope, elm, attrs, ctrl) {
        ctrl.$validators.customFieldError = function(modelValue, viewValue) {
          return true;
        };
      }
    };

  });

})();

